module.exports = __webpack_public_path__ + "img/ch.9c26f60a.svg";